.SRSCards {
    position: fixed;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 12px;
    z-index: 1000;
    max-width: 90vw;
    padding: 0 10px;
    background: var(--primary);
}

.Card {
    background: var(--background);
    border: 1px solid var(--border);
    border-radius: 8px;
    min-width: 180px;
    width: 180px;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }
}

.CardContent {
    flex: 1;
    padding: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    font-size: 12px;
    line-height: 1.4;
    position: relative;
    .extLLMLink {
        position: absolute;
        top: 8px;
        right: 8px;
        font-size: 10px;
        color: var(--muted-foreground);
        text-decoration: none;
        cursor: pointer;
        transition: color 0.2s ease;

        &:hover {
            color: var(--accent-foreground);
        }
    }
}

.CardFront {
    font-weight: 500;
    color: var(--foreground);
}

.CardBack {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid var(--border);
    color: var(--muted-foreground);
    font-size: 11px;
}

.CardButtons {
    display: flex;
    border-top: 1px solid var(--border);
    background: var(--muted);
}

.AnswerButton {
    flex: 1;
    padding: 6px 4px;
    border: none;
    background: transparent;
    color: var(--muted-foreground);
    font-size: 10px;
    cursor: pointer;
    transition: background-color 0.2s ease, color 0.2s ease;

    &:not(:last-child) {
        border-right: 1px solid var(--border);
    }

    &:hover {
        background: var(--accent);
        color: var(--accent-foreground);
    }

    &:first-child {
        border-bottom-left-radius: 8px;
    }

    &:last-child {
        border-bottom-right-radius: 8px;
    }
}
